var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconKeep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 7.2 12",
    width: 7.2,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6V1.2h.6V0h-6v1.2h.6V6L0 7.2v1.2h3.12V12h.96V8.4H7.2V7.2z"
  })));
}

export default SvgIconKeep;